import { createContext } from "react";

export const connectTheme = createContext();
